import { getDay, getTimeRange } from '@vfit/shared/hooks';
import { IFrameInput } from 'libs/shared/atoms/src/lib/Inputs/components/FrameInput/frameInput.models';
import { useMemo } from 'react';
import { IUseFrameDateInput } from './frameDateInput.models';

export const useFrameDateInput = ({ endDateTime, startDateTime, variant }: IUseFrameDateInput) => {
  const day = useMemo(() => getDay(startDateTime), [getDay, startDateTime]);

  const timeRange = useMemo(
    () => getTimeRange(startDateTime, endDateTime),
    [endDateTime, startDateTime]
  );

  const frameInputVariant: IFrameInput['variant'] = useMemo(
    () => (variant === 'long' ? 'tertiary' : 'secondary'),
    [variant]
  );

  return { day, frameInputVariant, timeRange };
};

